/**
 * On mobile, showing every size (including rarely-ordered 4XL/5XL) wraps
 * the picker onto a second row and pushes the rest of the form down. Show
 * only the common sizes and let shoppers reveal the rest on request.
 */
(function () {
  var VISIBLE_LIMIT = 6;
  var expandedFormIds = {};

  function formIdForWrapper(wrapper) {
    var input = wrapper.querySelector("input[form]");
    return input ? input.getAttribute("form") : null;
  }

  function expand(wrapper, button) {
    wrapper.classList.add("size-options--expanded");
    if (button) button.remove();

    var formId = formIdForWrapper(wrapper);
    if (formId) expandedFormIds[formId] = true;
  }

  function setUpWrapper(wrapper) {
    var optionCount = wrapper.querySelectorAll("label").length;
    if (optionCount <= VISIBLE_LIMIT) return;

    var formId = formIdForWrapper(wrapper);
    if (formId && expandedFormIds[formId]) {
      wrapper.classList.add("size-options--expanded");
      return;
    }

    if (
      wrapper.nextElementSibling &&
      wrapper.nextElementSibling.classList.contains("size-options-see-more")
    ) {
      return;
    }

    var hiddenCount = optionCount - VISIBLE_LIMIT;
    var button = document.createElement("button");
    button.type = "button";
    button.className = "size-options-see-more";
    button.textContent =
      "See " + hiddenCount + " more " + (hiddenCount === 1 ? "size" : "sizes");
    button.addEventListener("click", function () {
      expand(wrapper, button);
    });

    wrapper.insertAdjacentElement("afterend", button);
  }

  function initAll() {
    document
      .querySelectorAll(
        "fieldset[data-is-size-option] .form-options-wrapper.button-options",
      )
      .forEach(setUpWrapper);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  if (typeof webvista !== "undefined" && webvista.subscribe) {
    webvista.subscribe(PUB_SUB_EVENTS.variantChange, initAll);
  }
})();
